import { redirect } from 'react-router';

import { queryClient } from '@app/providers/query';

import { accountQueryOptions, type PrincipalType } from '@entities/shared/account';

import { resolveHomePath } from './resolve-home-path';

// Loader factory: gates a whole bucket on the account's principal type, keeping the
// client and tenant route trees mutually exclusive at the routing level. Reuses the
// session-cached account (shared with `privateMiddleware` via React Query — one request).
// A principal that lands in the wrong bucket is redirected to its resolved home — a page
// it can actually open (see `resolveHomePath`), never a fixed page that may itself be
// gated and bounce back (the old static `/admin/limit-templates` froze any tenant lacking
// `Tenant.Limits:Read` in an infinite / ↔ /admin/limit-templates redirect loop).
export const requirePrincipalType = (principalType: PrincipalType) => async () => {
  const account = await queryClient.ensureQueryData(accountQueryOptions());

  if (account.principalType !== principalType) throw redirect(await resolveHomePath());

  return null;
};
